module.exports = __webpack_public_path__ + "img/DiscountCircle.a752200.svg";